import { render, staticRenderFns } from "./Category_Detail.vue?vue&type=template&id=223c987c"
import script from "./Category_Detail.vue?vue&type=script&lang=js"
export * from "./Category_Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports